import { createGate } from 'effector-react'

export const DocumentsGate = createGate()
